import { createUseStoreWithSelectorDeferred } from "@captions-web/utils/zustand-store";
import { init, Mixpanel } from "mixpanel-browser";
import { createStore } from "zustand";
import { combine } from "zustand/middleware";

import { createStoreGetters } from "~/stores/root";

// token for mirage-studio mixpanel project
const MIXPANEL_TOKEN = "28edead44af903f52c7dade738c29f4c";

interface MixpanelStoreState {
  instance: Mixpanel;
}

export function createMixpanelStore() {
  return createStore(
    combine(
      { instance: init(MIXPANEL_TOKEN, {}, "mirage-studio") } as MixpanelStoreState,
      (_set, get) => {
        return {
          async init() {},
          identify(id: string, orgId: string) {
            const instance = get().instance;

            instance.identify(id);
            instance.people.set({
              platform: "mirage-studio",
              // we pass `user_id` to match mixpanel ios behavior
              user_id: id,
              org_id: orgId,
            });
          },
          track(event: string, properties?: Record<string, unknown>) {
            const instance = get().instance;
            instance.track(event, { ...properties });
          },
        };
      }
    )
  );
}

type MixpanelStore = ReturnType<ReturnType<typeof createMixpanelStore>["getState"]>;

export const {
  getStore: getMixpanelStore,
  getStoreAsync: getMixpanelStoreAsync,
  getStoreApi: getMixpanelStoreApi,
} = createStoreGetters<MixpanelStore>("mixpanel");

export const useMixpanelStore = createUseStoreWithSelectorDeferred(() => getMixpanelStoreApi());
